import { pageHeaderKrakowBlueprint } from "@made-people/blueprint-page-header/blueprint";

pageHeaderKrakowBlueprint.override({
  slots: {
    base: "flex flex-col w-full",
    breadcrumbs:
      "text-body-sm text-text-less-emphasis-2 [&>a:hover]:text-text-body gap-2 flex items-center hidden",
    image: "",
    textBlockWrapper: "",
    linkShortcutsWrapper: "empty:hidden my-6 lg:my-10",
  },
});
